import { initializeHomeHeroScrollTakeover } from '../js/components/hero-scroll';
import { initializeDifferentiatorsPinnedScroll } from '../js/components/differentiators-scroll';
import { initializeCertificationsPin } from '../js/components/certifications-scroll';
import { initializeGallerySliderScroll } from '../js/components/gallery-slider-scroll';
import { initializeVerticalGalleryHeroPin } from '../js/components/vertical-gallery-hero-pin';
import { initializeOurApproachSquiggleOnHeroEnd } from '../js/components/our-approach-squiggle-scroll';
import { initializeEventsHereSquiggleOnView } from '../js/components/events-here-squiggle-scroll';
import {
  prepareScrollTextRevealTargets,
  initializeScrollTextRevealAnimations
} from '../js/components/scroll-text-reveal';

var animationCleanups = [];

function destroyProjectAnimations() {
  animationCleanups.forEach(function runCleanup(cleanup) {
    if (typeof cleanup === 'function') {
      cleanup();
    }
  });

  animationCleanups = [];
}

export function initializeProjectInteractions() {
  prepareScrollTextRevealTargets();
}

export function initializeProjectAnimations() {
  destroyProjectAnimations();

  var homeHeroCleanup = initializeHomeHeroScrollTakeover();
  var differentiatorsCleanup = initializeDifferentiatorsPinnedScroll();
  var certificationsCleanup = initializeCertificationsPin();
  var gallerySliderCleanup = initializeGallerySliderScroll();
  var verticalGalleryHeroPinCleanup = initializeVerticalGalleryHeroPin();
  var approachSquiggleCleanup = initializeOurApproachSquiggleOnHeroEnd();
  var eventsHereSquiggleCleanup = initializeEventsHereSquiggleOnView();
  var scrollTextRevealCleanup = initializeScrollTextRevealAnimations();

  if (typeof homeHeroCleanup === 'function') {
    animationCleanups.push(homeHeroCleanup);
  }

  if (typeof differentiatorsCleanup === 'function') {
    animationCleanups.push(differentiatorsCleanup);
  }

  if (typeof certificationsCleanup === 'function') {
    animationCleanups.push(certificationsCleanup);
  }

  if (typeof gallerySliderCleanup === 'function') {
    animationCleanups.push(gallerySliderCleanup);
  }

  if (typeof verticalGalleryHeroPinCleanup === 'function') {
    animationCleanups.push(verticalGalleryHeroPinCleanup);
  }

  if (typeof approachSquiggleCleanup === 'function') {
    animationCleanups.push(approachSquiggleCleanup);
  }

  if (typeof eventsHereSquiggleCleanup === 'function') {
    animationCleanups.push(eventsHereSquiggleCleanup);
  }

  if (typeof scrollTextRevealCleanup === 'function') {
    animationCleanups.push(scrollTextRevealCleanup);
  }
}
